module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/jenny-craig-b22db4fe78245c6d8b05b0225acd2625.png";